import {requestApi} from '@/utils/httpClient';
import {requestManager} from '@/utils/ky-hooks/requestManager';

// 定义请求参数类型
/**
 *  初始算法文件上传接口
 * @param formData 表单数据
 * @returns Promise直接返回响应数据
 */
export async function initialUpload(params: FormData, jobId: string): Promise<ApiResponse> {
    return requestManager.execute(
        `uploadAlgorithm_${jobId}`,
        signal => requestApi.post('console/v1/jobs/initial/file_upload', params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 5 * 60 * 1000,
            signal
        })
    );
}

// 评估算法上传
export async function evaluateUpload(params): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/evaluator/file_upload', params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// 评估数据集上传
export async function datasetUpload(params): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/dataset/file_upload', params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

// 仿真环境上传
export async function simulatorsUpload(params): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/simulators/file_upload', params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

//  专家库上传
export async function expertUpload(params: FormData): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/expert/file_upload', params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

}

// 文件重命名
export async function renameFileApi(params): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/file_rename', params);
}

// 文件删除
export async function deleteFileApi(params): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/file_delete', params);
}

// bos上传获取sk ak token
export async function getStsToken(job_id: string): Promise<ApiResponse> {
    return requestApi.get(`console/v1/assume_role/generate/${job_id}`);
}

// bos 上传完成后，通知后端文件列表
export async function notifyBosUpload(params: {
    job_id: string;
    parent_path: string;
    cover_dir: boolean;
    initial_algorithm: BosFiles;
}): Promise<ApiResponse> {
    return requestApi.post('console/v1/jobs/initial/file_upload_bos_url', params);
}
